import * as React from "react";

function Workspace(props) {
  return (
    <svg x="0px" y="0px" viewBox="0 0 512 512" xmlSpace="preserve" {...props}>
      <path
        d="M256.001 512C397 512 511.999 397 511.999 255.999 511.999 115.001 397 0 256.001 0s-256 115.001-256 255.999C.001 397 115.002 512 256.001 512z"
        fill="#ff757c"
      />
      <path
        d="M218.59 357.619l-10.949 38.85-36.803 27.893v5.977h170.325v-5.977l-36.801-27.893-10.949-38.85-37.411-.496-37.412.496z"
        fill="#c8cacc"
      />
      <path d="M170.838 427.351v2.989h170.324v-2.989H170.838z" fill="#fff" />
      <path
        d="M65.982 52.788h380.035c12.486 0 22.702 10.216 22.702 22.7v234.105H43.283V75.488c0-12.484 10.215-22.7 22.699-22.7z"
        fill="#666"
      />
      <path
        d="M58.696 294.179h394.606V75.488c0-3.978-3.309-7.287-7.286-7.287H65.982c-3.977 0-7.286 3.309-7.286 7.287v218.691z"
        fill="#15bdb1"
      />
      <path
        d="M183.635 309.594h178.489l-134.947-125.56-63.726 63.262 20.184 62.298z"
        fill="#20d0c2"
      />
      <path
        d="M183.635 309.594h178.489l-16.567-15.415H178.641l4.994 15.415z"
        fill="#807d7d"
      />
      <path
        d="M208.034 228.48c8.455-8.395 8.357-22.204-.223-30.844-5.804-5.847-14.002-7.829-21.318-5.9l-7.121-7.173c-.851-.856-2.228-.877-3.065-.045l-11.224 11.143c-.838.832-.828 2.209.021 3.065l6.706 6.753c-2.545 7.585-.741 16.386 5.382 22.553 8.578 8.642 22.387 8.841 30.842.448z"
        fill="#fff"
      />
      <path
        d="M180.203 168.466l-16.231-16.35c-5.555-5.598-14.679-5.628-20.276-.074l-11.631 11.544c-5.597 5.559-5.63 14.684-.074 20.279l16.235 16.353c-3.751 14.445-.147 31.596 15.226 47.083l63.727-63.265c-15.375-15.49-32.499-19.217-46.976-15.57z"
        fill="#fbb429"
      />
      <path
        d="M132.369 163.284l-.304.301c-5.597 5.559-5.63 14.684-.074 20.279l16.235 16.353c-3.751 14.445-.147 31.596 15.226 47.083l1.937-1.923c-14.099-15.574-17.307-32.505-13.572-46.884l-17.045-17.167c-4.847-4.882-5.641-12.32-2.403-18.042z"
        fill="#f5a209"
      />
      <path
        d="M468.718 309.594v24.827c0 12.489-11.261 22.703-25.026 22.703H68.307c-13.763 0-25.024-10.214-25.024-22.703v-24.827h425.435z"
        fill="#fff"
      />
      <path
        d="M145.545 171.615l-65.913 114.21v131.9h22.158l-9.327-131.9 61.555-109.779c2.276-5-5.502-8.815-8.473-4.431z"
        fill="#0e7886"
      />
      <path d="M.011 451.524h511.978V430.34H.011v21.184z" fill="#807d7d" />
      <g fill="#fbb429">
        <path d="M168.413 417.725H53.022c-8.515 0-18.812 12.881-10.291 12.881h132.544c8.52 0 1.657-12.881-6.862-12.881zM86.048 276.896a9.19 9.19 0 00-9.191 9.19c0 5.077 4.115 9.191 9.191 9.191s9.19-4.114 9.19-9.191a9.19 9.19 0 00-9.19-9.19z" />
      </g>
      <path
        d="M86.048 281.55a4.536 4.536 0 100 9.073 4.536 4.536 0 000-9.073z"
        fill="#fff"
      />
      <path
        d="M154.202 413.783l-23.715-3.943v7.885h23.715v-3.942z"
        fill="#ff5b61"
      />
      <path
        d="M223.223 368.181h42.652a4.354 4.354 0 014.341 4.342v53.473a4.356 4.356 0 01-4.341 4.344h-42.652a4.356 4.356 0 01-4.342-4.344v-53.473a4.354 4.354 0 014.342-4.342z"
        fill="#fff"
      />
      <g fill="#ecf0f1">
        <path d="M270.217 380.4h12.006c3.968 0 7.212 2.811 7.212 6.25v29.536c0 3.437-3.244 6.251-7.212 6.251h-12.006v-4.971h12.006c.676 0 2.158-.443 2.158-1.28V386.65c0-.838-1.483-1.28-2.158-1.28h-12.006v-4.97zM264.369 430.34v-62.159h1.505c2.388 0 4.342 1.923 4.342 4.271v53.615c0 2.352-1.954 4.273-4.342 4.273h-1.505z" />
      </g>
      <path
        d="M235.855 397.295h12.925v11.483h-12.925v-11.483z"
        fill="#20d0c2"
      />
      <path
        d="M235.855 397.295h12.925l-.719-2.382H236.91l-1.055 2.382z"
        fill="#15bdb1"
      />
      <path
        d="M242.848 368.181v27.871c-.004.378-.899.396-.905 0v-27.871h.905z"
        fill="#fbb429"
      />
      <path d="M41.008 459.209h429.984v-7.682H41.008v7.682z" fill="#666" />
      <path
        d="M256 339.539c3.95 0 7.171-3.223 7.171-7.171 0-3.95-3.222-7.171-7.171-7.171-3.95 0-7.171 3.222-7.171 7.171-.001 3.948 3.221 7.171 7.171 7.171z"
        fill="#d0d1d4"
      />
      <path
        d="M356.374 201.428c-3.079-2.45-6.96-4.35-10.387-6.031-2.046-1.003-3.978-1.949-5.384-2.845-3.273-2.086-5.659-7.425-5.32-11.902.145-1.913.87-4.438 3.496-5.598 2.794-1.234 4.896.989 5.589 1.719 1.455 1.537 2.728 3.771 3.492 6.132.578 1.782.672 3.048.615 3.717a2.182 2.182 0 00-1.017 4.221c1.796.614 3.448.164 4.446-1.197 1.486 4.583 3.331 8.825 5.479 12.64a23.92 23.92 0 00-1.009-.856zm29.718 78.871h18.242v-1.913c-5.361-.345-12.364-12.337-12.785-18.819l-2.411-37.125c8.041-.997 15.386-5.894 21.267-13.493a11.07 11.07 0 00-.341 2.795c.019 2.978 1.65 5.512 4.364 6.785a8.365 8.365 0 003.535.787c1.821 0 3.606-.601 5.019-1.768 3.154-2.598 3.497-5.848 2.206-7.712-1.094-1.578-3.082-1.977-4.836-.967a2.18 2.18 0 00.961 4.064c-.189.342-.526.776-1.105 1.251-1.035.855-2.613 1.014-3.93.396-.69-.321-1.845-1.121-1.853-2.858-.014-2.459 1.288-4.645 4.098-6.88 2.707-2.156 6.365-3.948 9.59-5.528 2.16-1.057 4.198-2.057 5.81-3.086 2.266-1.443 4.261-3.892 5.615-6.896 1.32-2.926 1.927-6.126 1.709-9.011-.334-4.384-2.493-7.67-6.081-9.258-3.875-1.708-7.968-.427-11.231 3.52-.117.143-.232.288-.347.436.551-4.034.85-8.213.863-12.501H347.729c.013 4.287.312 8.467.862 12.501a12.303 12.303 0 00-.348-.436c-3.262-3.946-7.357-5.228-11.229-3.52-3.59 1.588-5.75 4.874-6.081 9.258-.22 2.886.387 6.086 1.707 9.011 1.357 3.004 3.35 5.453 5.616 6.896 1.613 1.029 3.651 2.029 5.81 3.086 3.227 1.581 6.885 3.372 9.593 5.528 2.81 2.235 4.113 4.421 4.098 6.88-.011 1.737-1.166 2.538-1.853 2.858-1.318.618-2.897.458-3.932-.396-.579-.475-.913-.909-1.105-1.251a2.18 2.18 0 00.962-4.064c-1.754-1.01-3.743-.612-4.834.967-1.292 1.865-.949 5.115 2.203 7.712 1.416 1.167 3.2 1.768 5.019 1.768a8.345 8.345 0 003.535-.787c2.716-1.273 4.347-3.807 4.364-6.785.006-.958-.108-1.89-.34-2.795 5.882 7.599 13.227 12.496 21.267 13.493l-2.409 37.125c-.421 6.482-7.426 18.473-12.787 18.819v1.913h18.245zm29.719-78.871a22.57 22.57 0 00-1.005.856c2.145-3.815 3.991-8.057 5.476-12.64 1.001 1.36 2.65 1.811 4.446 1.197a2.18 2.18 0 00-1.015-4.221c-.059-.668.038-1.934.615-3.717.763-2.361 2.037-4.595 3.492-6.132.691-.73 2.794-2.953 5.589-1.719 2.625 1.16 3.351 3.685 3.495 5.598.341 4.477-2.045 9.815-5.319 11.902-1.409.897-3.341 1.842-5.387 2.845-3.424 1.681-7.308 3.582-10.387 6.031z"
        fill="#fbb429"
      />
      <path
        d="M416.422 162.518s7.444 50.383-28.653 59.283l2.215 37.699c-.091 10.029 8.149 20.8 14.351 20.8v-1.913c-5.361-.345-12.364-12.337-12.785-18.819l-2.411-37.125c7.994-.99 15.3-5.837 21.167-13.361a.922.922 0 01.1-.132s2.809-3.295 4.895-7.101c-.17.144-.335.29-.496.435a63.3 63.3 0 001.759-3.362c1.879-4.472 3.718-9.278 3.718-9.278 1.11-3.541 2.587-9.472 3.31-14.626.551-4.034.85-8.213.863-12.501h-8.033v.001z"
        fill="#f5a209"
      />
      <g fill="#666">
        <path d="M412.374 313.639h-52.56v-29.478a3.867 3.867 0 013.858-3.862h44.841a3.868 3.868 0 013.862 3.862l-.001 29.478z" />
        <path d="M417.243 319.593H354.94v-4.983a3.51 3.51 0 013.507-3.507h55.29a3.507 3.507 0 013.506 3.507v4.983z" />
      </g>
      <path
        d="M425.395 162.518h-78.604a1.708 1.708 0 01-1.707-1.708v-.035c0-.942.765-1.706 1.707-1.706h78.604c.942 0 1.706.764 1.706 1.706v.035c0 .943-.764 1.708-1.706 1.708z"
        fill="#fbb429"
      />
      <path
        d="M312.611 352.871h138.7v4.68c-6.567 8.37-5.482 17.68 0 24.655v4.678h-138.7c-21.667 0-21.668-34.013 0-34.013z"
        fill="#20d0c2"
      />
      <path
        d="M451.31 382.206c-5.598-8.217-6.022-16.436 0-24.655H312.609c-6.522 0-11.871 5.556-11.871 12.327 0 6.772 5.35 12.327 11.871 12.327H451.31z"
        fill="#fff"
      />
      <g fill="#ecf0f1">
        <path d="M449.981 359.535a27.37 27.37 0 011.33-1.984H312.609c-13.264 0-16.983 19.011-3.606 24.063-9.134-4.445-5.724-19.604 3.864-22.079h137.114z" />
        <path d="M448.609 361.882h-145.01c.269-.324.55-.635.85-.93h144.63c-.165.309-.322.62-.47.93zm-146.222 1.756c-.172.302-.335.613-.481.93h145.666c.094-.31.196-.621.309-.93H302.387zm-1.141 2.685c-.091.305-.169.617-.236.931h145.958c.046-.311.1-.62.16-.931H301.246zm-.478 2.685c-.02.288-.029.578-.029.87v.063h146.046c-.002-.311.005-.62.019-.932H300.768v-.001zm.1 2.688c.045.314.101.625.17.929h145.966a16.16 16.16 0 01-.121-.929H300.868zm.696 2.685c.121.316.255.627.401.93h145.663a20.432 20.432 0 01-.264-.93h-145.8zm1.422 2.685c.225.323.463.633.714.931h144.983a22.03 22.03 0 01-.416-.931H302.986zm2.545 2.687a11.9 11.9 0 001.39.931h143.29c-.204-.306-.4-.618-.588-.931H305.531z" />
      </g>
      <path
        d="M463.204 386.884H302.315v5.976c7.618 10.695 6.359 22.591 0 31.503v5.977h160.889c25.135.001 25.135-43.456 0-43.456z"
        fill="#ff5b61"
      />
      <path
        d="M302.315 424.364c6.495-10.502 6.986-21.003 0-31.503h160.889c7.568 0 13.775 7.101 13.775 15.753 0 8.651-6.208 15.75-13.775 15.75H302.315z"
        fill="#fff"
      />
      <g fill="#ecf0f1">
        <path d="M303.857 395.397a34.664 34.664 0 00-1.542-2.537h160.889c15.389 0 19.703 24.292 4.183 30.748 10.598-5.683 6.641-25.05-4.48-28.211h-159.05z" />
        <path d="M305.45 398.395h168.21a15.816 15.816 0 00-.987-1.188H304.904c.192.394.375.792.546 1.188zm169.613 2.243c.2.387.387.784.559 1.19h-168.97c-.11-.398-.229-.793-.358-1.19h168.769zm1.325 3.431c.103.391.193.789.272 1.189H307.35a24.824 24.824 0 00-.186-1.189h169.224zm.555 3.433c.022.366.035.737.035 1.112l-.002.078H307.568c.001-.396-.006-.793-.022-1.189h169.397zm-.118 3.431c-.051.401-.117.798-.196 1.189H307.313c.057-.394.104-.792.142-1.189h169.37zm-.806 3.433c-.142.405-.298.8-.464 1.188H306.586c.112-.394.213-.789.306-1.188h169.127zm-1.649 3.431c-.262.413-.539.81-.832 1.19H305.362c.171-.394.332-.791.482-1.19H474.37zm-2.952 3.431c-.512.438-1.051.836-1.614 1.189H303.592c.237-.391.463-.786.681-1.189h167.145z" />
      </g>
      <path
        d="M438.76 318.802H331.666v4.677c5.071 8.37 4.233 17.68 0 24.656v4.677H438.76c16.733.001 16.734-34.01 0-34.01z"
        fill="#fbb429"
      />
      <path
        d="M331.666 348.135c4.324-8.218 4.65-16.438 0-24.656h107.096c5.034 0 9.168 5.558 9.168 12.33 0 6.771-4.134 12.326-9.168 12.326H331.666z"
        fill="#fff"
      />
      <g fill="#ecf0f1">
        <path d="M332.692 325.465a27.565 27.565 0 00-1.026-1.986h107.096c10.241 0 13.114 19.011 2.783 24.064 7.055-4.446 4.42-19.604-2.982-22.078H332.692z" />
        <path d="M333.753 327.812h111.968a12.286 12.286 0 00-.656-.932H333.39c.128.311.248.62.363.932zm112.902 1.754c.134.304.257.613.371.932H334.553a22.332 22.332 0 00-.238-.932h112.34zm.882 2.687c.068.307.13.615.18.931h-112.7c-.034-.311-.075-.62-.124-.931h112.644zm.369 2.686c.014.286.025.578.025.87l-.001.06H335.162a26.26 26.26 0 00-.015-.93h112.759zm-.076 2.686c-.035.314-.08.623-.132.93H334.993c.037-.309.07-.62.093-.93H447.83zm-.539 2.684c-.093.318-.198.627-.308.932H334.508c.074-.309.143-.62.205-.932h112.578zm-1.098 2.687a12.22 12.22 0 01-.552.932H333.696c.113-.308.219-.619.321-.932h112.176zm-1.963 2.687a9.328 9.328 0 01-1.074.929H332.517c.157-.307.308-.615.451-.929H444.23z" />
      </g>
      <path
        d="M149.3 171.981a2.77 2.77 0 100 5.54 2.77 2.77 0 000-5.54z"
        fill="#fff"
      />
    </svg>
  );
}

export default Workspace;
